import Cotacao from './cotacao';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    setValue,
    init,
    cotar,
    setForm,
    setUltAltVR
} from '../../store/cotacao/actions';

const mapStateToProps = (state, nextState) => ({
    cotacao: state.cotacaoReducer,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setValue,
        init,
        cotar,
        setForm,
        setUltAltVR
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cotacao);